// extracted by mini-css-extract-plugin
export default {"addPhoto":"UploadPhotoFeedPage_addPhoto__KYSAn","addIcon":"UploadPhotoFeedPage_addIcon__I8W55","categoryImage":"UploadPhotoFeedPage_categoryImage__ENLve"};